import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { DisenrollmentCategoriesRedux } from '../Redux/DisenrollmentCategoriesRedux'

const disenrollmentCategoriesCrudObservable = createCRUDObservable({
  mainRedux: DisenrollmentCategoriesRedux,
  reduxPath: 'disenrollment',
  dataHandlers: {},
})

export const disenrollmentCategoriesObservers = Object.assign({},
  disenrollmentCategoriesCrudObservable.observers, {})

export const disenrollmentCategoriesEpic = combineEpics(
  disenrollmentCategoriesCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/DisenrollmentCategoriesObservable.js